import { Checkbox, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FC } from 'react';

import { useModelContext } from '@app/contexts/model';
import { useStorageUserListContext } from '@app/modules/SelfConfig/contexts/storage';

type TProps = {};

export const MainLanguage: FC<TProps> = observer((props: TProps) => {
    const { usersListStore } = useStorageUserListContext();
    const { languageModel } = useModelContext();

    const categoryLangResponse = languageModel.dataCategory.get();

    const handleToggle = (value: string) => () => {
        if (usersListStore.mainLanguagesChosenIdSet.includes(value)) {
            usersListStore.mainLanguagesChosenIdSet.remove(value);
        } else {
            usersListStore.mainLanguagesChosenIdSet.push(value);
        }
    };

    return (
        <List>
            <Typography>
                Source languages selection
                <br />
                (select at least one)
            </Typography>
            {categoryLangResponse &&
                categoryLangResponse.main.map((value) => {
                    const labelId = `checkbox-list-label-${value.key}`;
                    return (
                        <ListItemButton key={value.key} role={undefined} onClick={handleToggle(value.key)} dense>
                            <ListItemIcon>
                                <Checkbox edge='start' className={'main-lang'} checked={usersListStore.mainLanguagesChosenIdSet.includes(value.key)} tabIndex={-1} disableRipple inputProps={{ 'aria-labelledby': labelId }} />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={`${value.name}`} />
                        </ListItemButton>
                    );
                })}
        </List>
    );
});
